<template>
  <div class="layer-page-div">
    <div class="big-img-div" v-show="isShowBigImg" @click="onHideBigImgDiv">
      <img ref="bigImg" src="" alt=""/>
    </div>
    <div class="layer-content-div">
      <validation-observer ref="form">
        <div class="item-div">
          <div class="row-div">
            <div class="item-name-div">所属分组：</div>
            <div class="item-control-div">
              <my-select class="group-select" :load-more="true" :action="action" :change="onChanged" placeholder-txt="请选择分组"/>
            </div>
          </div>
          <div class="tips-div"></div>
        </div>
        <div class="item-div">
          <validation-provider rules="required|max:10" v-slot="{ errors }" name="typeName">
            <div class="row-div">
              <div class="item-name-div">分类名称：</div>
              <div class="item-control-div">
                <label><input type="text" v-model="typeInfo.name" maxlength="10" placeholder="请输入分类名称名称"></label>
              </div>
            </div>
            <div class="tips-div err-tips">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="item-div">
          <div class="row-div">
            <div class="item-name-div">分类图标：</div>
            <div class="item-control-div">
              <div class="type-icon-div" v-show="typeIcon != null">
                <img class="del-img" src="../../assets/del.png" alt="" @click="onDelImg" />
                <img ref="img" src="" alt="" @click="onShowBigImgDiv($event)">
              </div>
              <div v-show="typeIcon == null">
                <label class="upload-img-label" @change="onAddImg($event)">
                  <img class="cursor-el" src="../../assets/picture.png" alt="" />
                  <input class="cursor-el" type="file" />
                </label>
              </div>
            </div>
          </div>
          <div class="tips-div"></div>
        </div>
        <div class="item-div">
          <validation-provider rules="max:10" v-slot="{ errors }" name="typeMemo">
            <div class="row-div">
              <div class="item-name-div">分类描述：</div>
              <div class="item-control-div">
                <label><input type="text" v-model="typeInfo.memo" maxlength="10" placeholder="请输入分类描述"></label>
              </div>
            </div>
            <div class="tips-div err-tips">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="item-div">
          <validation-provider rules="max:6" v-slot="{ errors }" name="typeTableName">
            <div class="row-div">
              <div class="item-name-div">属性表头：</div>
              <div class="item-header-div">
                <label><input type="text" v-model="typeInfo.rules[0]" maxlength="6" placeholder="请输入表头名称"></label>
                <label><input type="text" v-model="typeInfo.rules[1]" maxlength="6" placeholder="请输入表头名称"></label>
                <label><input type="text" v-model="typeInfo.rules[2]" maxlength="6" placeholder="请输入表头名称"></label>
              </div>
            </div>
            <div class="tips-div err-tips">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="operate-div">
          <div class="tips-div text-c err-tips">{{ tipMsg }}</div>
          <div class="text-c">
            <input type="button" value="取消" @click="onCancel">
            <input class="save-input" type="button" value="保存" @click="onSave">
          </div>
        </div>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import MySelect from "../../components/MySelect"
import { getBrandPartsGroupNameItems, postBrandPartsTypeAdd } from "../../common/api";

export default {
  components: { MySelect },
  props: {
    layerid: {
      type: String,
      default: ""
    },
    refreshData: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      action: getBrandPartsGroupNameItems,
      typeInfo: {
        groupId: 0,
        name: "",
        memo: "",
        rules: ["", "", ""]
      },
      typeIcon: null,
      isShowBigImg: false,
      tipMsg: ""
    }
  },
  methods: {
    onChanged(item) {
      this.typeInfo.groupId = item.id;
    },
    onAddImg(event) {
      if(event.target.files.length < 1){
        return;
      }
      if(!/\.(jpg|jpeg|png)$/.test(event.target.files[0].name.toLowerCase())){
        event.target.value = "";
        this.$layer.msg("图片类型仅支持jpg、jpeg和png格式");
        return;
      }

      let img = event.target.files[0];
      let that = this;
      let reader = new FileReader();
      reader.readAsDataURL(img);
      reader.onload = function() {
        that.$refs.img.src = reader.result;
        that.typeIcon = img;
        event.target.value = null;
      };
      reader.onerror = function() {
        this.onDelImg();
        that.$layer.msg("读取文件失败，请重试");
      };
    },
    onDelImg() {
      this.typeIcon = null;
      this.$refs.img.src = "";
    },
    onShowBigImgDiv(event) {
      this.$refs.bigImg.src = event.target.src;
      this.isShowBigImg = true;
    },
    onHideBigImgDiv() {
      this.isShowBigImg = false;
    },
    onCancel() {
      this.$layer.close(this.layerid);
    },
    onSave() {
      if(this.typeInfo.groupId <= 0){
        this.setTipsMsg("请选择所属分组");
        return;
      }

      if(this.typeIcon == null){
        this.setTipsMsg("请上传分类图标");
        return;
      }

      let headerCount = 0;
      this.typeInfo.rules.forEach(v => {
        if(v.length > 0){
          ++headerCount;
        }
      });
      if(headerCount > 0 && headerCount !== 3){
        this.setTipsMsg("使用表头时，字段必须是3个");
        return;
      }

      let formData = new FormData();
      formData.append("groupId", this.typeInfo.groupId);
      formData.append("name", this.typeInfo.name.trim());
      formData.append("file", this.typeIcon);
      if(this.typeInfo.memo.length > 0){
        formData.append("memo", this.typeInfo.memo.trim());
      }
      if(headerCount > 0){
        this.typeInfo.rules.forEach(v => {
          formData.append("rules", v.trim());
        });
      }

      this.$refs.form.validate().then(res => {
        if(res){
          postBrandPartsTypeAdd(formData)
            .then(() => {
              this.refreshData();
              this.$layer.close(this.layerid);
              this.$layer.msg("操作成功");
            })
            .catch(error => {
              if (Object.prototype.hasOwnProperty.call(error, "data") && Object.prototype.hasOwnProperty.call(error.data, "status")) {
                this.$layer.msg(error.data.msg);
              } else {
                this.$layer.msg("操作失败");
              }
            });
        }
      });
    },
    setTipsMsg(msg) {
      this.tipMsg = msg;
      clearTimeout(this.timeCounter);
      this.timeCounter = setTimeout(() => {
        this.tipMsg = "";
      }, 3000);
    }
  }
}
</script>

<style lang="less" scoped>
.layer-page-div {
  width: 100%;
  font-size: 14px;
  color: #2c3e50;
  .big-img-div {
    position: absolute;
    width: 100%;
    height: calc(100% - 42px);
    background-color: rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99;
    img {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
      align-items: center;
    }
  }
  .layer-content-div {
    width: 500px;
    margin: 20px auto 0 auto;
    .item-div {
      margin-top: 5px;
      .row-div {
        display: flex;
        align-items: center;
        .item-name-div {
          width: 70px;
          text-align: right;
          margin-right: 15px;
        }
        .item-control-div {
          input {
            width: 358px;
            height: 33px;
            padding: 0 5px;
            border: 1px solid #dcdcdc;
          }
          .group-select {
            width: 230px;
            height: 33px;
          }
        }
        .type-icon-div {
          width: 64px;
          height: 64px;
          position: relative;
          img {
            width: auto;
            height: auto;
            max-width: 100%;
            max-height: 100%;
          }
          .del-img {
            width: 16px;
            height: 16px;
            position: absolute;
            top: 0;
            right: 0;
          }
        }
        .item-header-div {
          input {
            width: 108px;
            height: 33px;
            padding: 0 5px;
            border: 1px solid #dcdcdc;
          }
          label:nth-child(2) {
            margin-left: 5px;
            margin-right: 5px;
          }
        }
      }
      .tips-div {
        width: calc(100% - 90px);
        height: 25px;
        margin-left: 90px;
      }
    }
    .operate-div {
      margin-top: 20px;
      input {
        width: 120px;
        height: 35px;
        color: white;
        font-size: 16px;
        border: none;
        background: #4676c8;
        margin-top: 10px;
      }
      .save-input {
        margin-left: 5px;
      }
      .tips-div {
        width: 100%;
        height: 25px;
        margin-top: 10px;
      }
    }
  }
}
</style>